import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { Nullable, PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { IJNativeEvent } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { Button } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Button";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { Dialog, DialogPropertyValues, IDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Dialog";
import { FileUpload } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/FileUpload";
import { PropertyEditorFileUpload } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorFileUpload";
import { ValidationPanel } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ValidationPanel";
import { NAMESPACE } from "./_Namespace";

export type ImportProcessDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type ImportProcessDialogProperties = {
    [name in keyof ImportProcessDialogPropertyValues]: Property<ImportProcessDialogPropertyValues[name]>
};

export interface IImportProcessDialog extends IDialog, ImportProcessDialogProperties
{
}

export class ImportProcessDialog extends Dialog implements IImportProcessDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ImportProcessDialog";
    public static override className = "ImportProcessDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ImportProcessDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okOnly,
                okButtonText: "Close",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected buttonUpload?: Button;
    protected validationPanel?: ValidationPanel;
    protected propertyEditorFileUpload?: PropertyEditorFileUpload;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ImportProcessDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _bindEvents()
    {
        super._bindEvents();

        Assert.isNotNullOrUndefined(this.buttonUpload, "this.buttonUpload");

        this.buttonUpload.on("click", { self: this }, this.onUploadClicked);
    }
    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.validationPanel =
            new ValidationPanel()
                .appendTo(this._containerElementRef.current);

        this.propertyEditorFileUpload =
            new PropertyEditorFileUpload({
                editMode: true,
                propertyDisplayName: "File"
            })
                .appendTo(this._containerElementRef.current);

        this.buttonUpload =
            new Button({
                text: "Import"
            })
                .appendTo(this._containerElementRef.current);

        return $$element;
    }
    protected override _createElementComplete()
    {
        super._createElementComplete();

        this.addCssClass("rad-control-dialog-import-process");
    }

    // #endregion

    // #region Event Handlers

    protected onUploadClicked(evt: IJNativeEvent)
    {
        const
            self = evt.data.self as this;

        Assert.isNotNullOrUndefined(self.propertyEditorFileUpload, "self.propertyEditorFileUpload");
        Assert.isNotNullOrUndefined(self.validationPanel, "self.validationPanel");

        const
            fileUpload = self.propertyEditorFileUpload.editorControl.get() as Nullable<FileUpload>;

        Assert.isNotNullOrUndefined(fileUpload, "fileUpload");

        self.validationPanel.setErrorMessages(null);

        fileUpload
            .uploadFilesAsync()
            .then(() =>
            {
                ServiceManager.getRequired(WebApiClientService)
                    .createApiMethodRequest("DataService", "CallDataService", { id: "b185975f-0e14-4944-b706-6353f0d67dc4", operation: "ImportProcess", data: fileUpload.value.get() })
                    .executeAsync()
                    .catch(error =>
                    {
                        if (error?.type === "ValidationApiException")
                        {
                            Assert.isNotNullOrUndefined(self.validationPanel, "self.validationPanel");
                            self.validationPanel.setErrorMessages(error.validationErrors.map((item: any) => item.errorMessage));
                        }
                    })
            });
    }

    // #endregion

    // #endregion
}

